import type { ReactNode } from 'react';
import { cn } from './cn';

/*
  Timeline — хронология событий объекта: точка по типу события, время, кто, что.
  Цвет только у точки (статусные токены); текст — токены текста.
*/

export type TimelineKind = 'alert' | 'ack' | 'change' | 'resolve' | 'note' | 'ai';

export interface TimelineItem {
  id: string;
  kind: TimelineKind;
  time: string;
  dateTime?: string;
  timeTitle?: string;
  title: ReactNode;
  description?: ReactNode;
  actor?: string;
}

const dot: Record<TimelineKind, string> = {
  alert: 'bg-danger',
  ack: 'bg-info',
  change: 'bg-fg-subtle',
  resolve: 'bg-success',
  note: 'bg-line-strong',
  ai: 'bg-ai',
};

export function Timeline({ items, className }: { items: TimelineItem[]; className?: string }) {
  return (
    <ol
      data-slot="timeline"
      className={cn('relative flex flex-col gap-4 border-l border-line pl-5', className)}
    >
      {items.map((it) => (
        <li key={it.id} className="relative">
          <span
            className={cn(
              'absolute top-1.5 -left-5 size-2 -translate-x-1/2 rounded-full ring-2 ring-card',
              dot[it.kind],
            )}
            aria-hidden
          />
          <div className="flex items-baseline justify-between gap-3">
            <div className="text-sm text-fg">{it.title}</div>
            <time
              dateTime={it.dateTime}
              title={it.timeTitle}
              className="shrink-0 font-mono text-2xs text-fg-subtle tabular-nums"
            >
              {it.time}
            </time>
          </div>
          {(it.description || it.actor) && (
            <div className="mt-0.5 text-xs text-fg-muted">
              {it.actor && <span className="font-medium text-fg-muted">{it.actor} · </span>}
              {it.description}
            </div>
          )}
        </li>
      ))}
    </ol>
  );
}
